import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient, private globals: Globals, private router: Router) { }

  getAllNotifications(entity) {
    //debugger
    let promise = new Promise((resolve, reject) => {
      /*let isAdmin = false;
      if (this.globals.authData.RoleId == 1 || this.globals.authData.RoleId == 2) {
        isAdmin = false;
      }*/
      this.http.post(this.globals.baseAPIUrl+'notification/get-all',entity)
      
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  getRecentNotifications(entity) {
    ////debugger
    let promise = new Promise((resolve, reject) => {
      // let isAdmin = 'false';
      // if (this.globals.authData.RoleId == 1 || this.globals.authData.RoleId == 2) {
      //   isAdmin = 'true';
      // }
      this.http.post(this.globals.baseAPIUrl+'notification/get-recent',entity)
      
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  clearDismissNotification(entity) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl+'notification/dismiss',entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}
